export const clubsMenuItems = [
  {
    key: "member_privileges",
    icon: "/assets/images/nav/nav_badge.png",
    path: "/#member_privileges",
  },
  {
    key: "earn_s_dollar",
    icon: "/assets/images/nav/nav_monetization.png",
    path: "/earn",
  },
  {
    key: "burn_s_dollar",
    icon: "/assets/images/nav/nav_monetization.png",
    path: "/redeem",
  },
  {
    key: "smart_academy",
    icon: "/assets/images/nav/nav_festival.png",
    path: "/smart_academy?type=smart_academy",
  },
  {
    key: "event_experience",
    icon: "/assets/images/nav/nav_festival.png",
    subMenu: [
      {
        key: "event_registration",
        labelKey: "header:event_registration",
        path: "/smart_academy?type=event_registration",
      },
      {
        key: "event_inquiry",
        labelKey: "header:event_inquiry",
        path: "/inquiry",
      },
    ],
  },
  {
    key: "latest_videos",
    icon: "/assets/images/nav/nav_festival.png",
    path: "/videos",
  },
  {
    key: "latest_blogs",
    icon: "/assets/images/nav/nav_festival.png",
    path: "/blogs",
  },
  {
    key: "services",
    icon: "/assets/images/nav/nav_support_agent.png",
    url_hk: "https://support-hk.samsung.com/prebooking/index.html",
    url_hk_en: "https://support-hk.samsung.com/prebooking/en/index.html",
  },
];
